import { scrollTo } from './utils/functions.js';

function requireAll(r){
  r.keys().forEach(r);
}

// const pageHeader = document.querySelector('.lp25-site-wrapper .page-header');
// const lastLookItem = document.querySelector('.lp25-site-wrapper .looks__item:last-child');
// let lastLookItemY = 0;
const pageBody = document.querySelector('body');
const pageWrapper = document.querySelector('.lp25-page-wrapper');
let pageHeight = pageWrapper.offsetHeight;
const heroSection = pageWrapper.querySelector('.lp25-page-wrapper .hero-section');
let windowHeight = window.innerHeight;
let count = 0;
let st = window.scrollY;

const resizeHandler = (e)=>{
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  // get x position of the footer
  // lastLookItemY = lastLookItem.getBoundingClientRect().top + window.scrollY;
  window.dispatchEvent(new Event('scroll'));
  windowHeight = window.innerHeight;
  heroSection.style.width = pageWrapper.offsetWidth + 'px';
  pageHeight = pageWrapper.offsetHeight;
}


window.addEventListener('load', resizeHandler);
window.addEventListener('resize', resizeHandler);


const prlxElems = document.querySelectorAll(".lp25-page-wrapper picture, .lp25-page-wrapper .prlx--fade");

let prevRectTop = 0;
const scrollHandler = () => {
  count = 0;
  prlxElems.forEach((prlxElem) => {

    const rect = prlxElem.getBoundingClientRect();

    if(rect.top < (windowHeight * 0.8)){  
              
      if(prevRectTop != rect.top){
        count = 0;
      }
      if(prlxElem.classList.contains("qued")){
        return;
      }
      timer(() => {
        prlxElem.classList.add("executed");
      }, 100 * count);
      prlxElem.classList.add("qued");
      count++;
      prevRectTop = rect.top;
    }


  });
};


const timer = (func, delay)=>{
  setTimeout(()=>{
    func();
  }, delay);
}

// Swiper.use([Autoplay, EffectCreative]);

function init() {
  pageWrapper.classList.remove("loaded");
  timer(() => {
    pageWrapper.classList.add("loaded");
  }, 1100); // 少し遅延させて適用

    
  scrollHandler();

// // 対象の要素を一括取得
// const prlxElems = document.querySelectorAll(".lp25-page-wrapper picture, .lp25-page-wrapper .prlx--fade");

// const observedElements = new WeakSet();


// const intersectionObserver = new IntersectionObserver((entries) => {
//   entries.forEach((entry) => {
//     const el = entry.target;

//     if (entry.isIntersecting && !observedElements.has(el)) {
//       timer(() => {
//         el.classList.add("executed");
//       }, 100 * count);
//       el.classList.add("qued");
//       observedElements.add(el);
//       count++;
//     }
//   });
// }, {
//   root: null,
//   rootMargin: '-50px 0px',
//   threshold: 0 // ← これが重要        // 少しでも表示されたら発火
// });

// // 初期読み込み時に一度だけ監視を開始
// prlxElems.forEach((el) => {
//   intersectionObserver.observe(el);
// });

  


}

window.addEventListener("load", init);

window.addEventListener("scroll", scrollHandler);



// trigger scroll event
window.dispatchEvent(new Event('scroll'));

// select a tag that contains # in href
const anchorLinks = document.querySelectorAll('.lp25-page-wrapper a[href^="#"]');

anchorLinks.forEach(link => {
  link.addEventListener('click', function(e) {
    e.preventDefault();
    const targetId = this.getAttribute('href').replace('#', '.');
    const targetElement = document.querySelector(targetId);
    const targetElementY = targetElement.getBoundingClientRect().top + window.scrollY;
    if (targetElement) {
      scrollTo({to: targetElementY, duration: 1000});
    }
  });
}
);





